import { faGift } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';

import styles from './styles.module.scss';
import { Update } from './useUpdatesIndicator.ts';
import List, { ListItem, ListItemText } from '../../List/index.ts';
import Modal from '../../Modal/index.js';
import Spacer from '../../Spacer/index.ts';

const ICONS = {
  UPDATES: faGift
};
export interface UpdatesModalProps {
  updates: Update[];
  onClose: () => void;
}
const UpdatesModal: React.FC<UpdatesModalProps> = ({ updates, onClose }: UpdatesModalProps) => (
  <Modal
    hasFooter={false}
    isDismissable
    title="Recent Updates"
    headerIcon={ICONS.UPDATES}
    width="500px"
    isOpenByDefault
    onClose={onClose}
    placement="center"
    className={styles['aglmd-global-nav__updates__modal']}
  >
    <List variant={['comfortable']}>
      {updates.map(({ timestamp, url, title, description }) => (
        <ListItem key={timestamp} href={url || undefined} hasDivider>
          <ListItemText
            variant={['comfortable', 'bold', 'title']}
            secondary={<Spacer top={1}>{description as JSX.Element}</Spacer>}
          >
            {title}
          </ListItemText>
        </ListItem>
      ))}
    </List>
  </Modal>
);

export default UpdatesModal;
